export default function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function refCallback(element) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(element);
      } else if (ref != null) {
        // As per https://github.com/facebook/react/issues/13029, it is
        // acceptable to mutate current.
        // eslint-disable-next-line no-param-reassign
        ref.current = element;
      }
    });
  };
}